<template>
  <div class="controleDialog">
    <div class="controleDialog_btn" @click="_onclick">
      <i :class="titles=='添加'?'el-icon-plus':'el-icon-edit'"></i>
      <div style="margin-left: 5px" v-if="titles!='编辑'">添加</div>
    </div>
    <el-dialog custom-class="customStyle" width="50%" :title="titles + '控制指令'" append-to-body :visible.sync="dialogVisible">
      <div>
        <el-form ref="form" class="formStyle" :model="form" label-width="70px">
            <el-form-item label="组名称">
                <el-input v-model="form.T_name"></el-input>
            </el-form-item>
             <el-form-item label="控制设备">
                <div>
                    <el-button icon="el-icon-plus"
                    @click="showinnerTable" type="primary">添加设备</el-button>
                    <el-table class="tableStyle" :data="form.T_text">
                        <el-table-column prop="date" label="设备名称">
                            <template slot-scope="scope">
                                {{scope.row[scope.row.names]}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="开关">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row[scope.row.swiperName]" active-color="#007bff"
                                    inactive-color="#ff4949" :active-value="1" :inactive-value="0">
                                </el-switch>
                            </template>
                        </el-table-column>
                       <el-table-column prop="name" label="操作">
                            <template slot-scope="scope">
                                <span @click="()=>form.T_text.splice(scope.$index,1)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submit">完成{{titles}}</el-button>
            
            <el-button type="danger" @click="removItem" v-if="titles=='编辑'">删除</el-button>

            <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </div>
      <el-dialog custom-class="customStyle" width="40%" title="添加设备" append-to-body
       :visible.sync="innerVisible" destroy-on-close>
            <el-table ref="multipleTable"
            :row-key="getRowKey"
            @selection-change="handleSelectionChange"
            class="tableStyle innerTable" :data="tableData" >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="d_name" label="设备名称">
                </el-table-column>
            </el-table>
    </el-table-column>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import {
    GroupAdd,GroupPu,Groupdel
} from "@/api/MovingRingMonitoring/index.js";
export default {
    props:{
        titles: {
            type: String,
            default: '添加'
        },
        row:{
            type: Object,
            default: () => {}
        },
        list:{
            type: Array,
            default: () => []
        }
    },
  name: "",
  data() {
    return {
        dialogVisible: false,
        innerVisible:false,
        form:{
            T_name:'',
            T_text:[]
        },
        tableData: []
    };
  },
  mounted() {},
  methods: {
        _onclick(){
            this.dialogVisible = true
            if(this.titles=='添加'){
                this.form.T_text = []
                this.form.T_name = ''
            }else{
                let obj = {...this.row}
                 const json = JSON.parse(obj.T_text)
                let {Id,T_name} = obj
                this.form = {
                    Id,T_name,
                    T_text:json,
                }
            }
        },
        submit(){
            if(this.form.T_name==''){
                this.$message.error('请输入组名称')
                return
            }
            if(this.form.T_text.length==0){
                this.$message.error('请添加控制设备')
                return
            }
            console.log(this.form);
            if(this.titles=='添加'){
                let obj = {...this.form}
                obj.T_text = JSON.stringify(obj.T_text)
                GroupAdd(obj).then(res => {
                    if (res.data.Code == 200) {
                        this.dialogVisible =false
                        this.$emit('refresh')
                        this.$message.success('添加成功')
                    }
                })
            }else{
                let obj = {...this.form}
                obj.T_text = JSON.stringify(obj.T_text)
                GroupPu(obj).then(res => {
                    if (res.data.Code == 200) {
                        this.dialogVisible =false
                        this.$emit('refresh')
                        this.$message.success('修改成功')
                    }
                })
            }
        },
        removItem(){
            let {Id} = this.form
            Groupdel({Id}).then(res => {
                if (res.data.Code == 200) {
                    this.dialogVisible = false
                    this.$emit('refresh')
                    this.$message.success('删除成功')
                }
            })
        },
        showinnerTable(){
            this.innerVisible = true
            let arr = [...this.list]
            //没有筛选d_show==false的
            const result = arr.reduce((acc, item) => {
                return acc.concat(item.arrJson.flatMap(subItem => subItem.T_dataJson));
            }, []);

            //筛选d_show==false的
            // const result = arr.flatMap(item => 
            //     item.arrJson.flatMap(subItem => 
            //         subItem.T_dataJson.filter(obj => obj.d_show !== false)
            //     )
            // );
           
            this.tableData = result
            this.$nextTick(()=>{
                //勾选
                this.form.T_text.forEach(formItem => {
                    const row = this.tableData.find(tableItem => 
                        tableItem.T_sn === formItem.T_sn && tableItem.keys === formItem.keys
                    );
                    if (row) {
                        this.$refs.multipleTable.toggleRowSelection(row, true);
                    }
                });
            })

        },
        getRowKey(row) {
            return `${row.T_sn}-${row.keys}`;
        },
        handleSelectionChange(selection) {
            // 清空当前的 form.T_text
            this.form.T_text = [];
            // 将选中的行添加到 form.T_text
            selection.forEach((selectedRow) => {
                this.form.T_text.push({ ...selectedRow });
            });
        },
  },
};
</script>

<style lang="scss">
// 去掉表格背景
.tableStyle{
    background-color: transparent !important;
    margin-top: 20px;
    // 去掉表格行背景
    .el-table__body tr,
    .el-table__header tr {
        background-color: transparent !important;
    }
    .el-checkbox__inner{
        background-color: transparent;
    }
    // 设置表格表头文字颜色
    .el-table__header th {
        color: #007bff;
    }

    // 设置表格表体文字颜色
    .el-table__body td {
        color: #007bff;
        
    }
    // 修改表格单元格边框颜色
    .el-table__body td,
    .el-table__header th {
        border:none;
    }
    // 设置表头高度
    .has-gutter .el-table__cell{
        padding: 0;
    }
    tr:hover>td.el-table__cell {
        background-color: rgba(#007bff,.1) !important;
        cursor: pointer;
    }

    .el-table__expand-icon {
        color: #007bff;
        font-size: 16px;
    }
    
}
// 设置表格表头背景颜色
.tableStyle th.el-table__cell {
    background-color: rgba(#007bff, .4);
    border-bottom: none !important;
}

.innerTable{
    margin-top: 0;
    .has-gutter .el-table__cell{
        padding: 10px 0;
    }
    .cell {
        padding: 0 10px ;
    }
}

.tableStyle::before {
    background-color: transparent !important;
}

</style>
<style lang="scss">
.controleDialog {
  &_btn {
    box-shadow: 0 0 10px rgba(#007bff, 0.5) inset;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px 4px 10px 4px;
    padding: 2px 8px;
    font-weight: 100;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 14px;
    border: 1px solid rgba(#007bff, 0.7);
    &:hover {
      transform: scale(1.1);
    }
  }
}

.formStyle .el-form-item__label{
    color: #007bff;
}
.formStyle .el-input__inner {
    background-color: rgba(#007bff,.1);
    border: 1px solid #007bff;
    color: #007bff;
}

.customStyle {
    height: 70%;
    width: 40%;
    display: flex;
    flex-direction: column;
    border: 2px solid rgba(#007bff,.7);
    background:rgba(#007bff,.1);
    box-shadow: 0 0 20px rgba(#007bff, 0.5) inset;
    backdrop-filter: blur(5px); 
    -webkit-backdrop-filter: blur(5px); // Safari 浏览器支持
    border-radius: 20px;
  }
 .customStyle .el-dialog__title {
    color: #007bff;
  }
  .customStyle .el-dialog__body {
    flex: 1;
    color: #007bff;
    overflow: auto;
  }
  .customStyle>.el-dialog__footer{
        padding: 0 !important;
  }
  .dialog-footer{
    padding: 10px 0;
    background: linear-gradient(to right, transparent 10%,rgba(#007bff,.5), transparent 90%);
    text-align: center;
  }
</style>
